import React from 'react';
import { Optional } from '@honda-canada/design-system-react';
import RecommendedVehiclesUI from './RecommendedVehiclesUI';
import { useAppSelector } from '../../core/utils';
import { selectDealer } from '../../core/reducers/dealer';
import { usePageState } from '../../utils/sitecoreContext';
import { selectTrimCardGridNextStepUrl } from '../../core/reducers/ui';
import { selectNumberOfInStockAndOnItsWayVehiclesByModelYear } from '../../core/reducers/vehicleListFilters';
import usePaymentData from './hooks/usePaymentData';
import useFetchRecommendedVehicles from './hooks/useFetchRecommendedVehicles';
import NotRenderedInExperienceEditor from '../NotRenderedInExperienceEditor';
import useFilteredCardsByVariant from '../TrimCardGrid/hooks/useFilteredCardsByVariant';
const THRESHOLD_OF_AVAILABLE_TRIMS = 6;
const precedenceParser = (precedence) => ({
    id: precedence.id,
    name: precedence.name,
    detKey: precedence.detKey.value,
});
const fieldsMapper = (fields) => {
    var _a, _b;
    return ({
        titleValue: fields.data.value.title.value,
        carsSedansPrecedence: (_a = fields.data.value.carsSedansPrecedence.models) === null || _a === void 0 ? void 0 : _a.map(precedenceParser),
        suvsTrucksPrecedence: (_b = fields.data.value.suvsTrucksPrecedence.models) === null || _b === void 0 ? void 0 : _b.map(precedenceParser),
    });
};
const RecommendedVehicles = ({ rendering, fields }) => {
    const { dealerName, dealerCode } = useAppSelector(selectDealer);
    const { titleValue, carsSedansPrecedence, suvsTrucksPrecedence } = fieldsMapper(fields);
    const title = dealerName ? titleValue === null || titleValue === void 0 ? void 0 : titleValue.replace('{dealerName}', `${dealerName}`) : '';
    const trimCardGridNextStepUrl = useAppSelector(selectTrimCardGridNextStepUrl);
    const { isFetching, isUninitialized, error } = useFilteredCardsByVariant(true, true);
    const isTrimCardGridReady = !isFetching && !isUninitialized && !error;
    const numOfAvailableTrims = useAppSelector(selectNumberOfInStockAndOnItsWayVehiclesByModelYear);
    const shouldShowRecommendedVehicles = !!dealerCode && numOfAvailableTrims < THRESHOLD_OF_AVAILABLE_TRIMS;
    const { data: recommendedVehicles } = useFetchRecommendedVehicles({
        carsSedansPrecedence,
        suvsTrucksPrecedence,
    }, shouldShowRecommendedVehicles && isTrimCardGridReady);
    const recommendedVehiclesWithPaymentData = usePaymentData(recommendedVehicles, isTrimCardGridReady);
    const pageState = usePageState();
    if (pageState === 'edit') {
        return React.createElement(NotRenderedInExperienceEditor, { componentName: rendering.componentName });
    }
    return (React.createElement(Optional, { when: shouldShowRecommendedVehicles && (recommendedVehicles === null || recommendedVehicles === void 0 ? void 0 : recommendedVehicles.length) },
        React.createElement(RecommendedVehiclesUI, { recommendedVehicles: recommendedVehiclesWithPaymentData !== null && recommendedVehiclesWithPaymentData !== void 0 ? recommendedVehiclesWithPaymentData : [], componentName: rendering.componentName, title: title, cardLinkPathName: trimCardGridNextStepUrl.href })));
};
export default RecommendedVehicles;
